import { format, getTime, formatDistanceToNow, formatISO } from 'date-fns';

// ----------------------------------------------------------------------

export function formatDateTimeWithoutTimezone(value) {
  if (!value) return value;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    return `${value.trim()}T00:00:00`;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const pad = (part) => String(part).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
    date.getMinutes()
  )}:${pad(date.getSeconds())}`;
}

export function formatLocalDateAsUtcMidnight(dateString) {
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return "Invalid Date";
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00.000Z`;
}
//13 Aug 2024
export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}
// Aug 13 2024
export function fDateMonth(date, newFormat) {
  // 'MMM dd yyyy';
  const fm = newFormat || 'MMM dd yyyy';

  return date ? format(new Date(date), fm) : '';
}
// Aug 13 2024 11:47 am
export function fDateTime(date, newFormat) {
  const fm = newFormat || ' MMM dd yyyy p';

  return date ? format(new Date(date), fm) : '';
}
// Aug 13 2024 11:47 am EST
export function fDateTimeWithTimezone(date, newFormat) {
  const dateTime = fDateTime(date, newFormat);
  if (!dateTime) return '';
  const d = new Date(date);
  const tz = d.toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ').pop();
  return `${dateTime} ${tz}`;
}
// Aug 13
export function fMonthDay(date, newFormat) {
  const fm = newFormat || 'MMM dd';
  return date ? format(new Date(date), fm) : '';
}
// Aug 13, 2024
export function fMonthDayYear(date, newFormat) {
  const fm = newFormat || 'MMM dd, yyyy';
  return date ? format(new Date(date), fm) : '';
}
// recive a date in this style 2023-10-31T15:10:45.9185634
// return a date in this style 10/31/2023
export function fMonthDayYearShort(date, newFormat = 'MM/dd/yyyy') {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    // Return an empty string or some other fallback if the date is invalid
    return '1';
  }
  return format(new Date(date), newFormat);
}

// return date in this style 10/31/23
export function fMonthDayYearShortYear(date, newFormat = 'MM/dd/yy') {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    // Return an empty string or some other fallback if the date is invalid
    return '1';
  }
  return format(new Date(date), newFormat);
}

// return hours and minutes in this style 10:00 AM
export function fHoursMinutes(date, newFormat = 'hh:mm a') {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    return '1';
  }
  return format(new Date(date), newFormat);
}

// return day of the week in this style Monday
export function fDayOfWeek(date, newFormat = 'EEEE') {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    return '1';
  }
  return format(new Date(date), newFormat);
}

// recive a date in this style 2023-10-31T15:10:45.9185634
// return a date in this style 10/31
export function fDayMonthDayShort(date, newFormat = 'EEEE MM/dd') {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    // Return an empty string or some other fallback if the date is invalid
    return '1';
  }
  return format(new Date(date), newFormat);
}

// date in this style   MAY 3, 10:00am
export function fMonthDayTime(date, newFormat) {
  const fm = newFormat || 'MMM dd, p';
  return date ? format(new Date(date), fm) : '';
}
// date in this style   MAY 3, 10:00am
export function fMonthDayTimeEST(date, newFormat) {
  //append est to the end
  const fm = newFormat || 'MMM dd, p';
  return date ? `${format(new Date(date), fm)} EST` : '';
}

export function fMonthDayTimeYearEST(date, newFormat) {
  //append est to the end
  const fm = newFormat || 'MMM dd, yyyy p';
  return date ? `${format(new Date(date), fm)} EST` : '';
}

export function fDayMonthDay(date, newFormat) {
  const fm = newFormat || 'EEEE, MMM dd';
  return date ? format(new Date(date), fm) : '';
}
export function fDayMonthDy(date, newFormat) {
  const fm = newFormat || 'EEE, MMM dd';
  return date ? format(new Date(date), fm) : '';
}

export function hoursLeftToDate(targetDate) {
  if (!targetDate) return '';

  const now = new Date();
  const target = new Date(targetDate);
  const diffInMilliseconds = target - now;
  const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

  if (Math.abs(diffInHours) <= 1) {
    if (diffInHours < 0) {
      return `1 hour ago`;
    }
    return `1 hour`;
  }
  if (diffInHours < 0) {
    return `${Math.ceil(Math.abs(diffInHours))} hours ago`;
  }
  return `${Math.ceil(diffInHours)} hours`;
}

/**
 *  date in this style MAY 3, 10:00am if its more then 1 year away add the year
 *
 * @param {date} date
 */
export function fMonthDayTimeYear(date, newFormat) {
  const ym = newFormat || 'MMM dd, yyyy p';
  const fm = newFormat || 'MMM dd, p';
  const now = new Date();
  if (date) {
    const d = new Date(date);
    if (d.getFullYear() === now.getFullYear()) {
      return format(d, fm);
    }
  }
  return date ? format(new Date(date), ym) : '';
}
export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

//yyyy-dd-mm
export function timestamp(date, newFormat) {
  const fm = newFormat || 'yyyy-MM-dd';
  return date ? format(new Date(date), fm) : '';
}

export const convertToUnix = (date) => {
  const dateObj = new Date(date);
  const unixTime = dateObj.getTime();
  return unixTime;
};

export function fISODateTime(date) {
  const fm = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
  return date ? format(new Date(date), fm) : '';
}

// return a date in this style 2024-02-09T00:00:00
export function fISODate(date) {
  return date ? formatISO(new Date(date)) : '';
}

// Parse date-only value into a local Date for date pickers without UTC day shifting.
export function parseDateOnlyToLocalDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;

  const datePart = String(value).split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);
  if (year && month && day) {
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

// Returns 'yyyy-MM-dd' using the local calendar date, never UTC
export function toDateOnlyString(value) {
  const d = parseDateOnlyToLocalDate(value);
  return d ? format(d, 'yyyy-MM-dd') : '';
}

// Format time from a date string to a more readable format (e.g., "10:00 AM")
export const fTime = (dateStr) => {
  if (!dateStr) return '';
  const dateObj = new Date(dateStr);
  return dateObj.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

// C# sets dates to 01/01/0001 when no date is set
// This function checks to see if the date's year is 0001, and if it is, returns an empty string
export const fMinDate = (date) => {
  date = new Date(date);
  if (Number.isNaN(date.getTime())) return '';
  return date.getUTCFullYear() === 1 ? '' : date;
};
